

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AdminAuthProvider, useAdminAuth } from './context/AdminAuthContext';

import LoginPage             from './pages/auth/LoginPage';
import DashboardPage         from './pages/dashboard/DashboardPage';
import UsersPage             from './pages/users/UsersPage';
import CropsPage             from './pages/crops/CropsPage';
import CropRequestsPage      from './pages/crops/CropRequestsPage';
import LandPage               from './pages/land/LandPage';
import SupportPage           from './pages/support/SupportPage';
import ModulesPage           from './pages/modules/ModulesPage';
import ClientsPage           from './pages/clients/ClientsPage';
import NotificationsPage     from './pages/notifications/NotificationsPage';
import SettingsPage          from './pages/settings/SettingsPage';
import CategoriesPage        from './pages/categories/CategoriesPage';
import NurseryManagementPage from './pages/nursery/NurseryManagementPage';
import AddNurseryCategories from './pages/nursery/AddNurseryCategories';
import SubscriptionsPage     from './pages/subscriptions/SubscriptionsPage';
import AnalyticsPage         from './pages/analytics/AnalyticsPage';
 import ReferralsPage        from './pages/referrals/ReferralsPage';

function ProtectedRoute({ children }) {
  const { admin, loading } = useAdminAuth();
  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', gap:12, color:'#6C757D', fontSize:13 }}>
      <div className="spinner spinner--lg" />
      <span>Loading admin panel...</span>
    </div>
  );
  if (!admin) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route path="/dashboard"     element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/users"         element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
      <Route path="/farmers"       element={<ProtectedRoute><UsersPage roleFilter="seller" /></ProtectedRoute>} />
      <Route path="/buyers"        element={<ProtectedRoute><UsersPage roleFilter="buyer" /></ProtectedRoute>} />
      <Route path="/agents"        element={<ProtectedRoute><UsersPage roleFilter="agent" /></ProtectedRoute>} />
      <Route path="/crops"         element={<ProtectedRoute><CropsPage /></ProtectedRoute>} />
      <Route path="/requests"      element={<ProtectedRoute><CropRequestsPage /></ProtectedRoute>} />
      <Route path="/land"          element={<ProtectedRoute><LandPage /></ProtectedRoute>} />
      <Route path="/support"       element={<ProtectedRoute><SupportPage /></ProtectedRoute>} />
      <Route path="/reports"       element={<ProtectedRoute><SupportPage /></ProtectedRoute>} />
      <Route path="/modules"       element={<ProtectedRoute><ModulesPage /></ProtectedRoute>} />
      <Route path="/clients"       element={<ProtectedRoute><ClientsPage /></ProtectedRoute>} />
      <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
      <Route path="/settings"      element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="/categories"    element={<ProtectedRoute><CategoriesPage /></ProtectedRoute>} />
      <Route path="/nursery-mgmt"            element={<ProtectedRoute><NurseryManagementPage tab="list"       /></ProtectedRoute>} />
      <Route path="/nursery-mgmt/plants"     element={<ProtectedRoute><NurseryManagementPage tab="plants"     /></ProtectedRoute>} />
      <Route path="/nursery-mgmt/categories" element={<ProtectedRoute><AddNurseryCategories /></ProtectedRoute>} />
      <Route path="/subscriptions" element={<ProtectedRoute><SubscriptionsPage /></ProtectedRoute>} />
      <Route path="/analytics"     element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
      
      <Route path="/referrals"      element={<ProtectedRoute><ReferralsPage /></ProtectedRoute>} />
      <Route path="/"  element={<Navigate to="/dashboard" replace />} />
      <Route path="*"  element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <AppRoutes />
        <Toaster position="top-right" toastOptions={{ duration:2500, style:{ fontSize:13, borderRadius:8 } }} />
      </AdminAuthProvider>
    </BrowserRouter>
  );
}